import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwitchRightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"switch_right"}/>
}
